export default {
	"accountsReceivable": {
		"mergeBill": "合并",
		"createBill": "创建账单",
		"importButtom": "导入费用",
		"billName": "账单名",
		"billNameInput": "请输入账单名(必填)",
		"billNameSelect": "请选择账单名(必选)",
		"billNo": "账单号",
		"checkPersonName": "对账人",
		"confirmPersonName": "确认人",
		"confirm": "确认账单",
		"complete": "完成对账",
		"dialogBillErrorTitle": "确认账单错误提示",
		"dialogBillCreateTitle": "创建账单",
		"orderCount": "进度(单)",
		"billStartDt": "起始日期",
		"billEndDt": "结束日期",
		"billingCost": "计算费用(元)",
		"adjustCosts": "调整费用(元)",
		"finalCosts": "最终费用(元)",
		"checkCost": "对方费用(元)",
		"differenceCosts": "对账差额(元)",
		"confirmDt": "确认时间",
		"checkDt": "对账时间",
		"importDialogTitle": "导入费用",
		"flagTips": "请选择多个同一货主且是未确认状态的账单才可以合并！",
		"selectDouble": "请至少勾选两条数据！"
	},
	"billingConfirm": {
		"bill": "账单",
		"bizCost": "业务费用",
		"fixedCost": "固定费用",
		"totalCost": "总费用",
		"downloadAccountbill": "下载计费",
		"recountBill": "重算计费",
		"adjustAccountBill": "调整账期",
		"changeBill": "切换账单",
		"systemCalculation": "系统计算",
		"userCalculation": "手工调整",
		"finalCalculation": "最终费用",
		"costConfirmationProgress": "费用确认进度",
		"billingRequestTime": "计费发起时间",
		"recalculation": "重算",
		"addFixedCost": "添加费用",
		"billingItemsName": "计费项目",
		"billingDescription": "费用说明",
		"orderBillTabLable": "运输单计费",
		"singleReConfirm": "反确认",
		"orderService": "下单服务",
		"orderBillingCost": "预计费用",
		"workServiceType": "作业服务",
		"orderServiceType": "调整后费用",
		"clear": "清除",
		"change": "调整",
		"exceptBill": "异常计费",
		"totalPay": "赔付总金额",
		"billInfo": "单据信息",
		"keyWords": "字段",
		"xkeyWords": "修正值",
		"wkeyWords": "作业值",
		"cost": "费用",
		"carInfo": "派车信息",
		"serviceInfo": "服务信息",
		"changeCost": "费用调整",
		"beforeCost": "调整前价(元)",
		"afeterCost": "调整后价(元)",
		"noCharge": "不计此费",
		"endDtDialogTitle": "调整结束日期",
		"changeBillDialogTitle": "切换账单",
		"billNameTitle": "修改账单名",
		"accountResetDialogTitle": "请选择重算项",
		"YS_YS": "运费(元)",
		"pickUpTime": "提货日期",
		"endTime": "收货日期",
		"billNameTips": "请选择账单名",
		"changeBillObjTips": "是否确认切换账单",
		"cleanAdjustTips": "是否确认清除调整",
		"adjustBillEndDtTips": "请选择账期结束日期"
	},
	"reconciliation": {
		"reConfirmFn": "重新确认",
		"recheckFn": "重新对账",
		"importBill": "导入&对账",
		"collectData": "对账进度",
		"oppositeValue": "对方值",
		"async": "同步",
		"fixTypeName": "修正车型",
		"oppositeTypeName": "对方车型",
		"fixPlateNo": "修正车牌",
		"selectTypeBool": "是否服务",
		"serviceItems": "服务项",
		"projectIdTips": "承运产品有误,不能同步!",
		"temperatureControlNoTips": "温控类型有误,不能同步!",
		"goodsTypeIdTips": "货品类型有误,不能同步!",
		"synProvinceOriginDistrictTips": "对方值始发省/市/区有误,不能同步!",
		"originatingSiteIdTips": "始发站点有误,不能同步!",
		"destinationProvinceTips": "对方值目的省/市/区有误,不能同步!",
		"destinationSiteIdTips": "目的站点有误,不能同步!",
		"ourStyle": "我方格式",
		"otherStyle": "对方格式"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/accountsReceivable/accountsReceivable.js